export enum BulkAddUIMessages {
  ApiId = 'Please enter an API ID',
  Status = 'Please enter a valid Status',
  ApiIdInvalid = 'Please make API ID a number'
}
